import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
import TextboxStyles from '../Inputs/Textbox/Textbox.styles';
const Container = styled.div `
  position: relative;
  display: block;
  margin: 0 0 26px;
  width: auto;

  &[data-type='hidden'] {
    margin-bottom: 0;
  }
`;
const Label = styled.label `
  display: inline-block;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 10px;

  @media ${until(Device.Tablet)} {
    flex: 1 0 100%;
  }
`;
const Description = styled.p `
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 10px;
  max-width: 670px;

  @media ${until(Device.Tablet)} {
    font-size: 14px;
    line-height: 24px;
  }
`;
const DescriptionContent = styled.div `
  margin-bottom: 10px;

  p {
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 10px;
    max-width: 670px;

    @media ${until(Device.Tablet)} {
      font-size: 14px;
      line-height: 24px;
    }
  }
`;
export const Icon = styled.span `
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  height: 20px;
  width: 20px;

  @media ${from(Device.Tablet)} {
    height: 24px;
    width: 24px;
  }
`;
const Error = styled.span `
  display: block;
  color: ${brand.validation.invalid};
  font-size: 14px;
  letter-spacing: -0.02em;
  line-height: 16px;
  margin: 8px 0 0 0;
`;
const Children = styled.div `
  display: flex;
  gap: ${fluid(24, 40)};
  flex-direction: column;

  ${Container}[data-layout='horizontal'] & {
    @media ${from(Device.Tablet)} {
      flex-direction: row;
    }
  }

  ${Container}[data-radio='true'] & {
    gap: 12px;
  }
`;
const FileInputsWrapper = styled.div `
  display: flex;
  gap: ${fluid(12, 16)};

  ${TextboxStyles.Container} {
    flex: 1;
  }
`;
export default {
    Container,
    Description,
    DescriptionContent,
    Error,
    Icon,
    Label,
    Children,
    FileInputsWrapper,
};
